import React from "react";
import { Link } from "@/components/common/Link";
export default function Trialbookingcta() {
  return <section data-section-id="245926" id="trialbookingcta" className="text-foreground py-24 px-6 flex items-center justify-center text-center transition-opacity duration-700 ease-in-out !bg-[rgba(15,86,93,1)] md:py-32 md:px-12">
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-8 !w-[989.988px] md:gap-10">
        <div className="flex flex-col gap-2">
          
          <h2 className="text-4xl font-default font-bold tracking-tight !w-[850px] md:text-5xl lg:text-6xl text-secondary">
            Bereit für Deine Veränderung?
          </h2>
        </div>
        
        <p className="font-default max-w-2xl leading-relaxed text-secondary !font-bold !text-2xl !w-[850px]">Erlebe unser ganzheitliches Konzept hautnah. Sichere Dir jetzt Deine exklusive Probebehandlung für nur 19€ und starte Deine Reise zu mehr Wohlbefinden und einer strahlenden Silhouette.</p>
        
        <div className="pt-4">
          <div className="mt-8 flex justify-center">
              <div className="zeeg-inline-widget w-full max-w-2xl" id="zeeg-embed-bodyconcept-by-linda-lymphdrainage" style={{
            minWidth: "320px",
            minHeight: "780px"
          }}></div>
              <script type="text/javascript" src="https://assets.zeeg.me/embed.min.js" data-user="bodyconcept-by-linda" data-event-type="lymphdrainage" data-redirect-parent="true" async></script>
          </div>
        </div>
      </div>
    </section>;
}